import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function KnowledgeBase() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('regulations');
  const [searchQuery, setSearchQuery] = useState('');

  const regulations = [
    {
      id: 1,
      title: '中华人民共和国公路法',
      category: '法律',
      updateDate: '2017-12-28',
      tags: ['公路', '基本法律'],
      summary: '为了加强公路的建设和管理，促进公路事业的发展，适应社会主义现代化建设和人民生活的需要...',
      issuer: '主席令',
    },
    {
      id: 2,
      title: '招标投标法',
      category: '法律',
      updateDate: '2019-03-02',
      tags: ['招标投标', '基本法律'],
      summary: '规范招标投标活动，保护国家利益、社会公共利益和招标投标活动当事人的合法权益...',
      issuer: '主席令',
    },
    {
      id: 3,
      title: '招标投标法实施条例',
      category: '行政法规',
      updateDate: '2018-03-01',
      tags: ['招标投标', '实施细则'],
      summary: '为了规范招标投标活动，根据《中华人民共和国招标投标法》制定本条例...',
      issuer: '国务院',
    },
    {
      id: 4,
      title: '收费公路管理条例',
      category: '行政法规',
      updateDate: '2013-05-01',
      tags: ['收费公路', '管理条例'],
      summary: '为了加强对收费公路的管理，规范公路收费行为，维护收费公路的经营者和使用者的合法权益...',
      issuer: '国务院',
    },
    {
      id: 5,
      title: '公路竞争审查条例',
      category: '行政法规',
      updateDate: '2020-06-15',
      tags: ['公路竞争', '审查'],
      summary: '为了规范公路竞争行为，维护公路市场秩序，保护公路经营者和使用者的合法权益...',
      issuer: '国务院',
    },
    {
      id: 6,
      title: '公路竞争审查条例实施办法',
      category: '部门规章',
      updateDate: '2021-03-20',
      tags: ['公路竞争', '实施办法'],
      summary: '为了贯彻落实《公路竞争审查条例》，制定本实施办法...',
      issuer: '国家市场监督管理总局',
    },
    {
      id: 7,
      title: '关于规范实施政府和社会资本合作新机制的指导意见',
      category: '部门规章',
      updateDate: '2022-08-10',
      tags: ['PPP', '政府合作'],
      summary: '为了规范实施政府和社会资本合作新机制，促进基础设施和公共服务领域投融资体制改革...',
      issuer: '国家发展和改革委员会、财政部',
    },
    {
      id: 8,
      title: '收费公路政府和社会资本合作制度操作指南',
      category: '部门规章',
      updateDate: '2023-01-15',
      tags: ['收费公路', 'PPP'],
      summary: '为了规范收费公路政府和社会资本合作项目的实施，制定本操作指南...',
      issuer: '交通运输部办公厅、国家发展和改革委员会办公厅',
    },
    {
      id: 9,
      title: '基础设施和公用事业特许经营管理办法',
      category: '部门规章',
      updateDate: '2023-05-20',
      tags: ['特许经营', '基础设施'],
      summary: '为了规范基础设施和公用事业特许经营活动，保护特许经营各方当事人的合法权益...',
      issuer: '国家发展和改革委员会、财政部、住房和城乡建设部、交通运输部、水利部、中国人民银行',
    },
    {
      id: 10,
      title: '经营性公路建设项目投资人招标投标管理规定（2019年修正版）',
      category: '部门规章',
      updateDate: '2019-12-01',
      tags: ['经营性公路', '投资人招标'],
      summary: '为了规范经营性公路建设项目投资人招标投标活动，保护招标投标活动当事人的合法权益...',
      issuer: '交通运输部',
    },
    {
      id: 11,
      title: '政府和社会资本合作项目审计经营协议（编制）范本（2024年试行版）',
      category: '标准范本',
      updateDate: '2024-03-01',
      tags: ['PPP', '审计经营'],
      summary: '为了规范政府和社会资本合作项目审计经营协议的编制，制定本范本...',
      issuer: '国家发展和改革委员会',
    },
    {
      id: 12,
      title: '经营性公路建设项目投资人招标文件范本文本',
      category: '标准范本',
      updateDate: '2023-09-15',
      tags: ['经营性公路', '招标文件'],
      summary: '为了规范经营性公路建设项目投资人招标文件的编制，制定本范本文本...',
      issuer: '交通运输部',
    },
    {
      id: 13,
      title: '四川省高速公路条例',
      category: '地方法规',
      updateDate: '2022-06-10',
      tags: ['高速公路', '四川'],
      summary: '为了加强高速公路的建设和管理，促进高速公路事业的发展，制定本条例...',
      issuer: '四川省人大',
    },
    {
      id: 14,
      title: '四川省高速公路项目审计经营管理办法',
      category: '地方规章',
      updateDate: '2023-02-20',
      tags: ['高速公路', '审计经营'],
      summary: '为了规范四川省高速公路项目审计经营管理活动，制定本办法...',
      issuer: '四川省人民政府办公厅',
    },
    {
      id: 15,
      title: '四川省高速公路项目审计经营方案编写大纲',
      category: '地方规章',
      updateDate: '2023-04-15',
      tags: ['高速公路', '方案编写'],
      summary: '为了规范四川省高速公路项目审计经营方案的编写，制定本大纲...',
      issuer: '四川省交通运输厅',
    },
    {
      id: 16,
      title: '四川省交通运输厅关于印发《收费公路政府和社会资本合作项目合同（暂行）》的通知',
      category: '地方规章',
      updateDate: '2023-07-01',
      tags: ['收费公路', 'PPP合同'],
      summary: '为了规范收费公路政府和社会资本合作项目合同的签订，制定本合同范本...',
      issuer: '四川省交通运输厅',
    },
    {
      id: 17,
      title: '四川省高速公路项目审计经营投标人投标文件参考文本（2022版）',
      category: '地方规章',
      updateDate: '2022-11-20',
      tags: ['高速公路', '投标文件'],
      summary: '为了规范四川省高速公路项目审计经营投标人投标文件的编制，制定本参考文本...',
      issuer: '四川省交通运输厅',
    },
    {
      id: 18,
      title: '四川省高速公路和社会资本合作项目投资人招标工作细则',
      category: '地方规章',
      updateDate: '2023-08-10',
      tags: ['高速公路', '招标细则'],
      summary: '为了规范四川省高速公路和社会资本合作项目投资人招标工作，制定本细则...',
      issuer: '四川省交通运输厅',
    },
    {
      id: 19,
      title: '国家发改委等9部门关于"进一步鼓励和引导社会资本参与重大工程项目建设的指导意见"',
      category: '政策文件',
      updateDate: '2023-10-25',
      tags: ['社会资本', '重大工程'],
      summary: '为了进一步鼓励和引导社会资本参与重大工程项目建设，制定本指导意见...',
      issuer: '国家发改委等',
    },
  ];

  const templates = [
    {
      id: 1,
      name: '公路工程施工总承包招标文件',
      projectType: '公路工程',
      usageCount: 156,
      rating: 4.8,
      lastUsed: '2024-01-15',
      tags: ['施工总承包', '公路', '标准范本'],
    },
    {
      id: 2,
      name: '桥梁工程专业承包招标文件',
      projectType: '桥梁工程',
      usageCount: 89,
      rating: 4.9,
      lastUsed: '2024-01-10',
      tags: ['专业承包', '桥梁', '技术复杂'],
    },
    {
      id: 3,
      name: '隧道工程施工招标文件',
      projectType: '隧道工程',
      usageCount: 67,
      rating: 4.7,
      lastUsed: '2024-01-08',
      tags: ['隧道', '高风险', '技术要求高'],
    },
    {
      id: 4,
      name: 'EPC总承包招标文件',
      projectType: '综合项目',
      usageCount: 134,
      rating: 4.6,
      lastUsed: '2024-01-20',
      tags: ['EPC', '设计施工一体化'],
    },
  ];

  const faqs = [
    {
      id: 1,
      question: '投标保证金金额如何设置？',
      answer: '根据《招标投标法实施条例》，投标保证金不得超过招标项目估算价的2%。实践中，一般设置为估算价的1%-2%之间。',
      category: '投标保证金',
      frequency: 45,
      tags: ['保证金', '金额设置'],
    },
    {
      id: 2,
      question: '评标委员会人数如何确定？',
      answer: '评标委员会由招标人代表和有关技术、经济等方面的专家组成，成员人数为5人以上单数，其中技术、经济等方面的专家不得少于成员总数的三分之二。',
      category: '评标委员会',
      frequency: 38,
      tags: ['评标', '委员会组成'],
    },
    {
      id: 3,
      question: '资格预审和资格后审如何选择？',
      answer: '投标人较多时建议采用资格预审，可以减少评标工作量；投标人较少或技术简单的项目可采用资格后审。',
      category: '资格审查',
      frequency: 32,
      tags: ['资格审查', '预审后审'],
    },
    {
      id: 4,
      question: '技术评分标准如何避免主观性？',
      answer: '应将评分标准细化为多个等级，每个等级给出明确的描述性标准，减少评委的自由裁量空间。建议采用"优、良、中、差"四级评分法。',
      category: '评分标准',
      frequency: 56,
      tags: ['技术评分', '客观化'],
    },
  ];

  const technicalSpecs = [
    {
      id: 1,
      category: '路基工程',
      specs: [
        { name: '路基压实度', standard: '≥95%（重型击实标准）', reference: 'JTG F10-2006' },
        { name: '路基弯沉值', standard: '按设计要求', reference: 'JTG D50-2017' },
        { name: '边坡稳定性', standard: '安全系数≥1.25', reference: 'JTG D30-2015' },
      ],
    },
    {
      id: 2,
      category: '路面工程',
      specs: [
        { name: '沥青混凝土压实度', standard: '≥96%', reference: 'JTG F40-2004' },
        { name: '平整度', standard: 'σ≤1.2mm', reference: 'JTG F80/1-2017' },
        { name: '抗滑性能', standard: 'BPN≥45', reference: 'JTG E60-2008' },
      ],
    },
    {
      id: 3,
      category: '桥梁工程',
      specs: [
        { name: '混凝土强度', standard: 'C30-C50', reference: 'JTG 3362-2018' },
        { name: '钢筋保护层厚度', standard: '±5mm', reference: 'JTG/T 3650-2020' },
        { name: '预应力张拉控制', standard: '应力+伸长量双控', reference: 'JTG/T 3650-2020' },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/agent/dashboard')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-900">智能知识库</h1>
                <p className="text-sm text-gray-500">法规库、范本库、常见问题库、技术规范库</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索法规、范本、问题..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-96 pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Tabs */}
        <div className="bg-white rounded-xl shadow-sm mb-6">
          <div className="flex border-b border-gray-200">
            <button
              onClick={() => setActiveTab('regulations')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors cursor-pointer ${
                activeTab === 'regulations'
                  ? 'text-purple-600 border-b-2 border-purple-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-book-line mr-2"></i>
              法规库
            </button>
            <button
              onClick={() => setActiveTab('templates')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors cursor-pointer ${
                activeTab === 'templates'
                  ? 'text-purple-600 border-b-2 border-purple-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-file-copy-line mr-2"></i>
              范本库
            </button>
            <button
              onClick={() => setActiveTab('faqs')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors cursor-pointer ${
                activeTab === 'faqs'
                  ? 'text-purple-600 border-b-2 border-purple-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-question-answer-line mr-2"></i>
              常见问题库
            </button>
            <button
              onClick={() => setActiveTab('technical')}
              className={`flex-1 px-6 py-4 text-center font-semibold transition-colors cursor-pointer ${
                activeTab === 'technical'
                  ? 'text-purple-600 border-b-2 border-purple-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-tools-line mr-2"></i>
              技术规范库
            </button>
          </div>
        </div>

        {/* Regulations Tab */}
        {activeTab === 'regulations' && (
          <div className="space-y-4">
            {regulations.map((reg) => (
              <div key={reg.id} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <h3 className="text-lg font-bold text-gray-900">{reg.title}</h3>
                      <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-semibold">
                        {reg.category}
                      </span>
                    </div>
                    <p className="text-gray-600 text-sm mb-3">{reg.summary}</p>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <span><i className="ri-building-line mr-1"></i>发布单位：{reg.issuer}</span>
                      <div className="flex items-center space-x-2">
                        {reg.tags.map((tag, idx) => (
                          <span key={idx} className="px-2 py-1 bg-gray-100 rounded text-xs">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 ml-4">
                    <button className="px-4 py-2 text-purple-600 border border-purple-600 rounded-lg hover:bg-purple-50 whitespace-nowrap cursor-pointer">
                      <i className="ri-eye-line mr-2"></i>
                      查看
                    </button>
                    <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 whitespace-nowrap cursor-pointer">
                      <i className="ri-file-add-line mr-2"></i>
                      引用
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Templates Tab */}
        {activeTab === 'templates' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {templates.map((template) => (
              <div key={template.id} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{template.name}</h3>
                    <div className="flex items-center space-x-4 text-sm text-gray-500 mb-3">
                      <span><i className="ri-folder-line mr-1"></i>{template.projectType}</span>
                      <span><i className="ri-file-list-line mr-1"></i>使用 {template.usageCount} 次</span>
                    </div>
                    <div className="flex items-center space-x-2 mb-3">
                      {template.tags.map((tag, idx) => (
                        <span key={idx} className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">{tag}</span>
                      ))}
                    </div>
                    <div className="flex items-center space-x-4 text-sm">
                      <div className="flex items-center space-x-1">
                        <i className="ri-star-fill text-yellow-500"></i>
                        <span className="font-semibold text-gray-900">{template.rating}</span>
                      </div>
                      <span className="text-gray-500">最后使用：{template.lastUsed}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <button className="flex-1 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 whitespace-nowrap cursor-pointer">
                    <i className="ri-eye-line mr-2"></i>
                    预览
                  </button>
                  <button className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 whitespace-nowrap cursor-pointer">
                    <i className="ri-file-copy-line mr-2"></i>
                    使用范本
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* FAQs Tab */}
        {activeTab === 'faqs' && (
          <div className="space-y-4">
            {faqs.map((faq) => (
              <div key={faq.id} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-question-line text-2xl text-orange-600"></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-lg font-bold text-gray-900">{faq.question}</h3>
                      <div className="flex items-center space-x-2">
                        <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-semibold">
                          {faq.category}
                        </span>
                        <span className="text-sm text-gray-500">
                          <i className="ri-question-answer-line mr-1"></i>
                          被问 {faq.frequency} 次
                        </span>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 mb-3">
                      <p className="text-gray-700">{faq.answer}</p>
                    </div>
                    <div className="flex items-center space-x-2">
                      {faq.tags.map((tag, idx) => (
                        <span key={idx} className="px-2 py-1 bg-gray-100 rounded text-xs text-gray-600">{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Technical Specs Tab */}
        {activeTab === 'technical' && (
          <div className="space-y-6">
            {technicalSpecs.map((category) => (
              <div key={category.id} className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center mr-3">
                    <i className="ri-tools-line text-cyan-600"></i>
                  </div>
                  {category.category}
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b border-gray-200">
                        <th className="text-left py-3 px-4 font-semibold text-gray-700">技术指标</th>
                        <th className="text-left py-3 px-4 font-semibold text-gray-700">标准要求</th>
                        <th className="text-left py-3 px-4 font-semibold text-gray-700">参考规范</th>
                        <th className="text-right py-3 px-4 font-semibold text-gray-700">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {category.specs.map((spec, idx) => (
                        <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50">
                          <td className="py-3 px-4 text-gray-900">{spec.name}</td>
                          <td className="py-3 px-4 text-gray-700">{spec.standard}</td>
                          <td className="py-3 px-4">
                            <span className="px-2 py-1 bg-cyan-50 text-cyan-700 rounded text-sm font-mono">
                              {spec.reference}
                            </span>
                          </td>
                          <td className="py-3 px-4 text-right">
                            <button className="px-3 py-1 text-cyan-600 hover:bg-cyan-50 rounded cursor-pointer text-sm">
                              <i className="ri-file-add-line mr-1"></i>
                              引用
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
